import { useState } from "react";
import { Box, Button, Card, Container, Heading, Text } from "@chakra-ui/react";

import { Overline } from "../../components";
import { Google, Okta } from "../../theme/icons";
import API, { TAuthProvider } from "../../api";

function Auth() {
  const [ error, setError ] = useState<string>();

  const redirectToLogin = (provider: TAuthProvider) => {
    API.getAuthenticationUrl(provider)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Unable to get authentication URL");
        }
        return response.json();
      })
      .then((r) => window.location.assign(r.authorization_url))
      .catch((e) => setError(e.message));
  };

  return (
    <Container placeContent="center" display="grid">
      <Card p="8" w="50ch">
        <Heading size="lg">Log in or sign up</Heading>
        <Overline mb="8">Requires authorization</Overline>
        {error && <Text mb="2">{error}</Text>}
        <Box display="flex" flexDirection="column" gap="3">
          <Button
            sx={{ "> span": { position: "absolute", left: "1rem" }, "&:hover": { textDecoration: "none"} }}
            variant="outline"
            colorScheme="gray"
            leftIcon={<Google />}
            onClick={() => redirectToLogin("google")}
          >
            Continue with Google
          </Button>
          <Button
            sx={{ "> span": { position: "absolute", left: "1rem" }, "&:hover": { textDecoration: "none"} }}
            variant="outline"
            colorScheme="gray"
            leftIcon={<Okta />}
            onClick={() => redirectToLogin("okta")}
          >
            Continue with Okta
          </Button>
        </Box>
      </Card>
    </Container>
  );
}

export default Auth;
